import {
  EventSyncInterface,
  EventSyncLocalStorageAdapter,
  EventSyncNeo4jAdapter,
} from "../alias";
import { Neo4jConfig, neo4jClientFactory } from "./neo4jClient";
import { GameCommandByPlayer } from "./game/gameReducerFactory";

export type SyncAdapterProps = {
  gameId: string;
  gameName: string;
  neo4jConfig?: Neo4jConfig;
};

export const eventSyncAdapterFactory = <GameCommand>({
  gameId,
  gameName,
  neo4jConfig,
}: SyncAdapterProps): EventSyncInterface<GameCommandByPlayer<GameCommand>> => {
  const stateKey = `${gameName}-${gameId}`;
  if (neo4jConfig) {
    return new EventSyncNeo4jAdapter(
      neo4jClientFactory(neo4jConfig),
      stateKey,
      `${gameName} Event`
    );
  } else {
    return new EventSyncLocalStorageAdapter(500, stateKey);
  }
};
